import { Card, CardContent, styled } from '@mui/material';

export const StyledCard = styled(Card)`
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-radius: 8px;
  background: #f2f2f2;
`;

// Used in CohortBuilderEmptyStateCard
export const StyledCardEmptyState = styled(Card)`
  border-radius: 4px;
  margin-top: 24px;
  border: none;
  box-shadow: none;
`;

export const StyledCardContentEmptyState = styled(CardContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
